module.exports = __webpack_public_path__ + "img/google-play-badge.9ee2a112.png";